import { VDataTable } from 'vuetify/lib/components/index.mjs';

const VDataTableDefaults: Partial<VDataTable> = {
  hideDefaultFooter: true,
  headerProps: {
    class: ['text-capitalize'],
    height: 48,
    style: 'opacity: 1',
  },
  // @ts-ignore rowProps exists
  // rowProps: {
  //   // class: ['text-capitalize'],
  //   height: '40px !important',
  //   // color: item.color,
  // },
  cellProps: {
    class: ['text-capitalize'],
    height: 48,
  },
  // rowProps: {
  //   height: 28,
  // },
};

export default VDataTableDefaults;
